import { Box, Button, Divider, Paper, Stack, Typography } from '@mui/material'
import { YesNoChipBox } from '@planning/components/dangerous-goods/YesNoChipBox'
import { useTranslate } from '@tolgee/react'
import { PlusIcon } from '@tom-ui/ui'
import { IFormStore, useRegisterSubFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import {
  OrderSealsSubFormStore,
  OrderSealsSubFormType,
  OrderSealType,
} from '../stores/OrderSealsSubFormStore'
import { SealWithTypeSelection } from './SealWithTypeSelection'

export const OrderSealsSubForm = observer(
  <T,>({
    formStore,
    name,
    initialValues,
    isSmallView,
    onChangeHasSeals,
    onChangeSeals,
  }: {
    formStore: IFormStore<T>
    name: keyof T
    initialValues?: Partial<OrderSealsSubFormType>
    isSmallView?: boolean
    //These are provisory to work with react forms and should be removed once all the forms are migrated
    onChangeHasSeals?: () => void
    onChangeSeals?: () => void
  }) => {
    const { t } = useTranslate()
    const store = useRegisterSubFormStore(
      formStore,
      name,
      new OrderSealsSubFormStore(initialValues),
    )

    useEffect(() => {
      store.setValues(initialValues)
    }, [initialValues, store])

    return (
      <Paper variant='outlined' sx={{ p: '1rem' }}>
        <Box>
          <Stack direction='column' gap={0.5}>
            <Box display='flex' alignItems={'center'} justifyContent='space-between'>
              <Typography variant='subtitle2' fontWeight='bold'>
                {t('seals', 'Seals')}
              </Typography>
              <YesNoChipBox
                activeOption={store.hasSeals.value ? 'Yes' : 'No'}
                onClickYes={() => {
                  store.hasSeals.setValue(true)
                  onChangeHasSeals?.()
                }}
                onClickNo={() => {
                  store.hasSeals.setValue(false)
                  onChangeHasSeals?.()
                }}
              />
            </Box>
            {store.hasSeals.value && (
              <Stack gap={1} marginTop={1.5}>
                {store.seals.value.map((seal: OrderSealType, index: number) => (
                  <>
                    <SealWithTypeSelection
                      key={index}
                      index={index}
                      seal={seal}
                      isSmallView={isSmallView}
                      onChange={() => {
                        onChangeSeals?.()
                      }}
                      onDelete={() => {
                        store.removeSeal(index)
                        onChangeSeals?.()
                      }}
                    />
                    <Divider sx={{ my: 1 }} />
                  </>
                ))}
                <Box>
                  <Button
                    type='button'
                    variant='contained'
                    color='inherit'
                    onClick={() => {
                      store.addSeal()
                    }}
                    startIcon={<PlusIcon />}
                  >
                    {t('addSeal', 'Add seals')}
                  </Button>
                </Box>
              </Stack>
            )}
          </Stack>
        </Box>
      </Paper>
    )
  },
)
